import {AutoComplete, Icon, Input} from 'antd';
import {debounce} from 'lodash';
import {ClientSummary} from '../api/dtos/dtos';
import * as React from 'react';
import locales from '../locales';
import {DataSourceItemType} from 'antd/lib/auto-complete';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import furoApi from '../api/FuroApi';
import Config from '../config';
import {SelectValue} from 'antd/lib/select';
import ClientDetailsAlert from './ClientDetailsAlert';

import './ClientSelector.css';

interface ClientSelectorProps {
  editable?: boolean;
  client?: ClientSummary;
  onSelect: (client?: ClientSummary) => void;
}

interface ClientSelectorState {
  searchResults: ClientSummary[];
}

class ClientSelector extends React.Component<ClientSelectorProps, ClientSelectorState> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  private readonly debouncedOnClientSearch: (value: string) => void;

  constructor(props: ClientSelectorProps) {
    super(props);

    this.state = {
      searchResults: [],
    };

    this.debouncedOnClientSearch = debounce(this.onClientSearch, Config.SEARCH_DEBOUNCE_TIMEOUT).bind(this);
  }

  public render(): React.ReactNode {
    const {client, editable} = this.props;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        {this.props.client === undefined && <AutoComplete
            style={{width: '100%'}}
            size="default"
            className="form-item-with-suffix mild-disabled"
            dataSource={this.renderClientResultOptions()}
            placeholder={locales.search}
            disabled={!editable}
            optionLabelProp="text"
            onSelect={this.onClientSelect}
            onSearch={this.debouncedOnClientSearch}
        >
            <Input suffix={<Icon type="search"/>}/>
        </AutoComplete>}

        {client && <ClientDetailsAlert closable={editable}
                                       client={client}
                                       onClose={this.onClientDeselect}/>}
      </>
    );
  }

  private renderClientResultOptions = (): DataSourceItemType[] => {
    const opts = this.state.searchResults;
    return opts ? opts.map((cs: ClientSummary) => (
      <AutoComplete.Option key={String(cs.id)} value={String(cs.id)}>
        {cs.name}<br/><span style={{fontSize: 12, color: 'gray'}}>{cs.address}</span>
      </AutoComplete.Option>
    )) : [];
  };

  private onClientSelect = (value: SelectValue) => {
    this.clearClientResults();

    const id = Number(value);
    const selected = this.state.searchResults.find((cs: ClientSummary) => cs.id === id);
    if (selected) {
      this.props.onSelect(selected);
    }
  };

  private onClientDeselect = () => {
    this.props.onSelect(undefined);
  };

  private clearClientResults = () => {
    this.setState({
      searchResults: [],
    });
  };

  private onClientSearch = (value: string) => {
    if (value.length < 3) {
      // Don't run search with therms shorter than 3 characters
      return;
    }

    // TODO implement a client search api
    const promise = furoApi.clients.getAll({
      page: 0,
      pageSize: 20,
      sortOrder: 'ascend',
      sortColumnKey: 'name',
      filters: {'name': [value]}
    }).then(response => {
      this.setState({searchResults: response.results.content,})
    });

    withLoadingOverlay(promise, this.loadingHandler);
  };

}

export default ClientSelector;


// WEBPACK FOOTER //
// ./src/client-details/ClientSelector.tsx